import React, {useState, useEffect} from 'react';
import Popup from '../common/components/Popup';
import TextInput from '../common/components/TextInput';

interface renamePopupProps {
    showPopup: boolean,
    userRoleName: string,
    handleRename: (name: string) => void,
    handleClose: (value: boolean) => void,
}

function RenameRolePopup(props: renamePopupProps) {
    const {showPopup, userRoleName, handleClose, handleRename} = props;

    const [
        roleName,
        setRoleName,
    ] = useState<string>('');

    useEffect(() => {
        setRoleName(userRoleName);
    }, [
        userRoleName,
    ]);

    return (
        <Popup
            show={showPopup}
            onClose={() => handleClose(false)}
            title='Change Role Name'
            size='lg'
            primaryCtaText='Update'
            disablePrimaryCta={roleName === ''}
            primaryCtaOnClick={() => handleRename(roleName)}
            secondaryCtaText='Cancel'
            secondaryCtaOnClick={() => handleClose(false)}
        >
            <div className='mb-2'>
                <label className='form-label'>Role Name</label>
                <TextInput
                    type='text'
                    placeholder='Enter Role Name'
                    onChange={(text) => setRoleName(text)} 
                    text={roleName}
                    style={{width: '100%'}}/>
            </div>
        </Popup>
    );
}

export default RenameRolePopup;
